import { FC, useEffect, useRef } from "react";
import type { SupportTicketMessage } from "../model/types";
import { TicketMessage } from "./TicketMessage";

import styles from "./TicketMessageList.module.css";

interface Props {
  messages: SupportTicketMessage[];
}

export const TicketMessageList: FC<Props> = ({ messages }) => {
  const listRef = useRef<HTMLDivElement>(null);

  // Тред открывается на последнем сообщении и докручивается при новых.
  useEffect(() => {
    const list = listRef.current;
    if (list) list.scrollTop = list.scrollHeight;
  }, [messages.length]);

  return (
    <div className={styles.list} ref={listRef}>
      {messages.map((message) => (
        <TicketMessage key={message.id} message={message} />
      ))}
    </div>
  );
};
